import i18n from 'i18n-literally'

import { Alert, type AlertProps } from '@mui/material'
import { styled } from '@mui/material/styles'

// Takes the filled inputs' colors instead of MUI's bright outlined info, and
// stretches with left-aligned copy inside the code screen's centered column.
const Note = styled(Alert)(({ theme }) => ({
  alignSelf: 'stretch',
  backgroundColor: theme.palette.primary.enabled,
  borderColor: theme.palette.primary.disabled,
  color: theme.palette.text.primary,
  textAlign: 'left',
  '& .MuiAlert-icon': {
    color: theme.palette.primary.main,
  },
}))

const PhoneLoginNote = ({ sx }: Pick<AlertProps, 'sx'>) => (
  <Note severity="info" variant="outlined" sx={sx}>
    {i18n`Works only with a number you've already verified in your AROYA account.`}
  </Note>
)

export default PhoneLoginNote
